import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_FractionalKnapsack = () => (
  <DAAModuleSubtopic
    title="Greedy Method – Fractional Knapsack Problem"
    videos={[
      "https://www.youtube.com/embed/xZfmHVi7FMg",
      "https://www.youtube.com/embed/oTTzNMHM05I"
    ]}
    takeaways={[
      { text: "Goal: Maximize the total value in the knapsack." },
      { text: "Unlike 0-1 Knapsack, fractions of items can be taken." },
      { text: "Choose items with the highest value-to-weight ratio first." },
      { text: "Time Complexity: O(N log N) due to sorting items by ratio." },
      { text: "Greedy works here as local optimal = global optimal in fractional cases." },
    ]}
    questions={[
      {
        text: "Suppose on a single machine four jobs with profit values (100,10,15,27) and their respective deadline unit values (2,1,2,1) are given. Calculate feasible solutions using greedy method for optimal profit."
      },
      {
        text: "State the fractional knapsack problem. Solve it using greedy method for n = 7, W = 23, profits = (29, 17, 20, 19, 6, 28, 42), weights = (7, 5, 6, 3, 9, 2, 5). Show all steps."
      },
      {
        text: "Define Greedy Knapsack. Find optimal solution for n = 7, M = 15, profits = (10, 5, 15, 7, 6, 18, 3), weights = (2, 3, 5, 7, 1, 4, 1)."
      },
      {
        text: "You're attending multiple workshop sessions in a day. Design a greedy algorithm to attend the maximum number of sessions without overlap and implement the solution."
      }
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/_vHCtwx-EW4",
      "https://www.youtube.com/embed/sxnUt4yqsf8",
      "https://www.youtube.com/embed/1WFuZnC4A94"
    ]}
  />
);

export default  DAA_FractionalKnapsack ;
